<div class="app-layout">

  <!-- Header wrapper with user info overlay -->
  <div class="header-wrapper">
    <!-- User Profile Section - Positioned before header content -->
    <div class="header-user-overlay">
      <div class="header-user-inner">
        <div class="user-info">
          <img [src]="userProfileImage" [alt]="userName" class="user-profile-image" />
        </div>
      </div>
    </div>
    <np-header
      [sitename]="'substantiation assessment tool'"
      [welcomeMessage]="userName"
      [hasEnterpriseSearch]="false">
    </np-header>
  </div>

  <!-- NextPage Navigation Component -->
  <np-nav [navItems]="navigationItems"></np-nav>

  <!-- Sub-bar: breadcrumb + last synced -->
  <div class="app-sub-bar">
    <div class="app-sub-bar-inner">
      <span class="breadcrumb-text">{{ breadcrumb }}</span>
    </div>
  </div>

  <!-- Main Content Area -->
  <main class="app-content">
    <router-outlet></router-outlet>
  </main>

  <!-- NextPage Footer Component -->
  <np-footer
    [copyright]="'2026 All rights reserved.'"
    [opCoName]="'CVX Development'">
  </np-footer>

</div>
